const API = `${window.location.origin}/api`;

export function trackView(page, slug, churchId, linkId = '') {
  try {
    const body = JSON.stringify({ type: 'view', page, slug, church_id: churchId, link_id: linkId });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API}/analytics/track`, new Blob([body], { type: 'application/json' }));
    } else {
      fetch(`${API}/analytics/track`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true });
    }
  } catch {}
}

export function trackClick(page, slug, churchId, linkId = '', extra = {}) {
  try {
    const body = JSON.stringify({ type: 'click', page, slug, church_id: churchId, link_id: linkId, extra });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API}/analytics/track`, new Blob([body], { type: 'application/json' }));
    } else {
      fetch(`${API}/analytics/track`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true });
    }
  } catch {}
}

export function trackConversion(page, slug, churchId, linkId = '', extra = {}) {
  try {
    const body = JSON.stringify({ type: 'conversion', page, slug, church_id: churchId, link_id: linkId, extra });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API}/analytics/track`, new Blob([body], { type: 'application/json' }));
    } else {
      fetch(`${API}/analytics/track`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true });
    }
  } catch {}
}
